import { Navigate } from 'react-router-dom';
import { useSession } from '../hooks/useSession.tsx';
import { useT } from '../i18n/index.ts';

/**
 * `/` entrypoint. Bounces the user to `/dashboard` when authenticated
 * or `/login` when the session probe came back 401. While the probe is
 * still pending we render a minimal "checking session" placeholder so
 * the first paint doesn't flash the login form.
 */
export function RootRedirect(): JSX.Element {
  const { status } = useSession();
  const t = useT();
  if (status === 'loading') {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-surface px-8 text-sm text-outline"
        role="status"
        aria-live="polite"
      >
        <p>{t('common.session.checking')}</p>
      </div>
    );
  }
  if (status === 'authenticated') {
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to="/login" replace />;
}
